export default function UKInfo() {
    return (
        <>
            {/* Main Colored Section */}
            <section className="w-full bg-[#C67B3E] py-12 px-4 sm:px-6 lg:px-16">
                <div className="max-w-7xl mx-auto text-center lg:text-left">
                    
                    <h3 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white mb-6">
                        UK Student Visa Consultant in Ahmedabad
                    </h3>

                    <p className="text-justify text-base sm:text-lg lg:text-xxl text-white/90 leading-relaxed max-w-8xl mx-auto lg:mx-0">
                        Dreaming of studying in the United Kingdom but unsure how to begin the visa process? 
                        Our experienced UK Student Visa Consultants in Ahmedabad make your journey simple, 
                        structured, and stress-free. With over 13+ years of expertise and thousands of 
                        successful student placements, we provide end-to-end guidance — from selecting the 
                        right university and course to completing your visa application with confidence.
                    </p>

                    <br />

                    <p className="text-justify text-base sm:text-lg lg:text-xxl text-white/90 leading-relaxed max-w-8xl mx-auto lg:mx-0">
                        Our comprehensive services include university and course selection, UK student visa 
                        documentation support, embassy procedure guidance, application review, and 
                        pre-departure assistance. Our expert team ensures accuracy, compliance, and timely 
                        submissions so you can focus on preparing for your academic journey. 
                        Let us simplify your path to studying in the UK and help turn your dream into reality.
                    </p>

                </div>
            </section>
        </>
    );
}